<template lang="pug">
  .div
    .columns
      .column.is-3(v-for="(c, index) in cotizaciones")
        a.button.is-text.is-medium(@click="downloadCotizacion(c.rutaFile)" )
          span.icon
            i.far.fa-file-pdf
          span {{`Cotización ${index + 1}`}}
</template>

<script>
  import InventarioServices from '../../services/inventario/inventario'

  export default {
    name: 'Cotizaciones',
    props: {
      cotizaciones: {
        type: Array,
        default: []
      },
    },
    methods: {
      iniciarComponente() {
        
      },
      downloadCotizacion (rutaFile) {
        var currentUrl = window.location.hostname
        console.log(currentUrl)
        let link = `https://${currentUrl}${rutaFile}`

        window.open(link, '_blank')
      }
    },
    created () {
      this.iniciarComponente()
    },

  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/Cotizaciones.vue